import profile from '../other/profile';
import additionalCost from '../shared/additionalCost';
import additionalDocument from '../shared/additionalDocument';
import address from '../shared/address';
import bill from '../shared/bill';
import contact from '../shared/contact';
import document from '../shared/document';
import notes from '../shared/notes';
import payment from '../shared/payment';
import paymentDocument from '../shared/paymentDocument';
import rentalObject from '../shared/rentalObject';

const generalTenant = `
    additionalCosts {
        ${additionalCost}
    }
    additionalDocuments {
        ${additionalDocument}
    }
    agreement {
        ${document}
    }
    bankAccount {
        iban
        id
        name
    }
    bankAccountId
    billingAddress {
        ${address}
    }
    billingAddressId
    billings {
        ${bill}
    }
    #billReportBasePrice
    caseHeros
    caseId
    created
    debtorLawyer {
        ${contact}
        caseNumber
    }
    description
    #discount
    finished
    generalTenantCaseType
    id
    incomingPayments {
        ${payment}
    }
    inputCompleted
    inputOverview {
        ${document}
    }
    lastMail
    lastStatusChange
    monitions {
        ${paymentDocument}
    }
    nextDeadline
    ${notes}
    outgoingPayments {
        ${payment}
    }
    ownerSub
    partitionKey
    path
    productType
    profile {
        ${profile}
    }
    referrer {
        id
        referringPartner
    }
    rentalObject {
        ${rentalObject}
    }
    rentalObjectId
    report {
        ${document}
    }
    reportBasePrice
    requestsPayments {
        ${paymentDocument}
    }
    resubmissions {
        author
        message
        remember
    }
    sales
    signatures {
        id
        signature
        tenantId
    }
    status
    type
    warning
`;

export default generalTenant;
